<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code :title="`${$t('menu.tutorials')}`">
        <Tutorials />
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import Tutorials from './tablas/Tutorials.vue'

export default {
  components: {
    AppCardCode,
    Tutorials,
  },
}
</script>
